import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import router from '@/router'
import html2canvas from 'html2canvas'

// Vue.config.devtools = true
let hosts = require('./host-config.js')
const digitsRE = /(\d{3})(?=\d)/g
function rap (urlList) {
  let obj = {}
  for (var key in urlList) {
    if (urlList.hasOwnProperty(key)) {
      obj[key] = hosts.host + urlList[key]
    }
  }
  return obj
}

// 获取url的指定参数值
function getUrlParam (key) {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
  var r = location.search.substr(1).match(reg)
  if (r) {
    return decodeURI(r[2])
  }
  return ''
}

// 获取url的所有参数值
function getUrlParams () {
  let arr = location.search.substr(1).split('&')
  let arr2 = location.hash.slice(location.hash.search(/\?/) + 1).split('&')
  let obj = {}
  arr.concat(arr2).forEach(function (o, i) {
    let temp = o.split('=')
    if (temp[1]) obj[temp[0]] = decodeURI(temp[1])
  })
  return obj
}

// 获取hash的参数值
function getHashParms () {
  let arr = location.hash.slice(location.hash.search(/\?/) + 1).split('&')
  let obj = {}
  arr.forEach(function (o, i) {
    let temp = o.split('=')
    if (temp[1]) obj[temp[0]] = decodeURI(temp[1])
  })
  return obj
}

// 验证手机
function checkphone (phone) {
  let rule = /^1\d{10}$/
  // if (rule.test(phone)) {
  //   return true
  // }
  // return false
  return rule.test(phone)
}
// 验证真实姓名
function checkRealName(name) {
  return /^([\u4e00-\u9fa5]){2,4}$/.test(name)
}
// 验证密码
function checkPwd (pwd) {
  let rule = /^(?=.*[a-zA-Z]?)(?=.*\d?)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]?).{6,18}$/
  // if (rule.test(phone)) {
  //   return true
  // }
  // return false
  return rule.test(pwd)
}
/**
 * 异步获取后台数据
 * @param {string} url 请求的url地址
 * @param {Object} data 请求的参数对象,默认值为undefined
 * @param {bool} check 如果传参需要原json {list:[{id:1}]}，传false
 * @return {Promise} 返回一个promise对象
 */
function fetch (url, data = undefined, check = true, option = {}) {
  let formData = null
  if (data) {
    formData = Object.keys(data)
    formData.forEach(item => {
      if (typeof data[item] === 'object') {
        data[item] = JSON.stringify(data[item])
      }
    })
  }
  let ss = check ? qs.stringify(data) : data
  return new Promise((resolve, reject) => {
    axios.post(url, ss).then((response) => {
      let result = response.data
      // if (result.status === 403 && url !== '/pc/accountSecurity/AccountSecurity/getUser') {
      //   location.href = '/login.html'
      // }
      console.log('result ~~~~~~~~~~~~~:', result)
      const errStatus = [500, 5001]
      const _compneyId_ = location.hash.match(/\d+/)[0]
      if (errStatus.includes(result.status)) {
        if (!option.notCheckCard && result.message === '便捷卡用户未登录') {
          router.replace(`/ccLogin/${_compneyId_}`)
        }
        reject(result)
      } else {
        resolve(result)
      }
    }).catch((error) => {
      reject(new Error(error))
    })
  })
}

/**
 * 分割数组
 * @param {list} 要分割的数组  [1,2,3,4,5,6,7]
 * @param {num} 每份分割的数量 3
 * @return {Array} 返回分割后的数组 [[1,2,3],[4,5,6],[7]]
 */
function spliceList (list, num) {
  list = list || []
  let tList = []
  let temp = []
  for (let i = 0; i < list.length; i++) {
    if (i % num !== 0 || i === 0) {
      temp.push(list[i])
    } else {
      tList.push(temp)
      temp = []
      temp.push(list[i])
    }
  }
  tList.push(temp)
  return tList
}
/**
 * 分割字符串成数组
 * @param {str} 要分割的字符串  “a;b;c;d;”
 * @param {separator} 分割符   ";"
 * @return {Array} 返回分割后的数组 [a,b,c,d]
 */
function strToList (str, separator) {
  return str.split(separator).filter(function (o, i) {
    return !!o
  })
}
/**
 * 设置手机号中间4位为星号
 * @param {phone} 要设置的手机号
 * @return {string} 返回 136****4525
 */
function setPhone (phone) {
  return phone.substr(0, 3) + '****' + phone.substr(7)
}
function setIdCard (idCard) {
  return idCard.substr(0, 5) + '******' + idCard.substr(11)
}
/**
 * 判断密码是否存在空格
 * @param {str} 验证的密码字符串”
 */
function checkPwdTrim (str) {
  let reg = /\s+/g
  return reg.test(str)
}

/**
 * 判断密码等级
 */
function AnalyzePasswordSecurityLevel (password) {
  var securityLevel = 0
  if (/[A-Za-z]/.test(password)) {
    securityLevel++ // lowercase
  }
  if (/[0-9]/.test(password)) {
    securityLevel++ // digital
  }
  if (containSpecialChar(password)) {
    securityLevel++ // specialcase
  }
  return securityLevel
}
/**
 * 是否含有特殊符号
 */
function containSpecialChar (str) {
  var containSpecial = RegExp(/[(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/)
  return (containSpecial.test(str))
}

/**
 * 验证身份证号格式
 */
function idCard (str) {
  let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(str)
}
/**
 * 验证邮箱
 */
function checkEmail (str) {
  let reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  return reg.test(str)
}

// 日期格式化 yyyy-MM-dd hh:mm:ss
// @param {str} 'yyyy-MM-dd hh:mm:ss'
// @param {Date} new Date()
function datetimeFormat (fmt, date) {
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 去除空格
 * @param  {[type]} str  传入的字符串
 * @param  {[type]} type  1-所有空格  2-前后空格  3-前空格  4-后空格
 * @return {[type]}      去除空格后的新字符串
 */
function trim (str, type) {
  switch (type) {
    case 1:
      return str.replace(/\s+/g, '')
    case 2:
      return str.replace(/(^\s*)|(\s*$)/g, '')
    case 3:
      return str.replace(/(^\s*)/g, '')
    case 4:
      return str.replace(/(\s*$)/g, '')
    default:
      return str
  }
}

/**
  * 12345 => $12,345.00
  * 金额过滤器
  * @param {String} sign
  * @param {Number} decimals Decimal places
 */
function currency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '¥'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

/**
 * 超出省略隐藏
 * @param str 需要截取的字符串
 * @param number 需要截取字符串的个数
 */
function omit (str, number) {
  if (str.length > number) {
    return str.substring(0, number) + '...'
  } else {
    return str
  }
}
/**
 * 大于万的格式化
 * @param {any} val
 * @returns
 */
function TenThousand (val) {
  return val > 10000 ? (val / 10000).toFixed(1) + '万' : val
}
/**
 * 获取cookie
 * @param {string} cname
 * @returns
 */

function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function setCookie (cname, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cname + '=' + escape(value) + ';expires=' + exdate.toGMTString() + ';path=/'
}
/**
 * 验证车牌号
 * @param {string} vehicleNumber
 * @returns
 */

function isVehicleNumber(vehicleNumber) {
  var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[ABCDEFGHJKLMNPQRSTUVWXYZ]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
  var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[ABCDEFGHJKLMNPQRSTUVWXYZ]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
  if (vehicleNumber.length === 7) {
    return creg.test(vehicleNumber)
  } else if (vehicleNumber.length === 8) {
    return xreg.test(vehicleNumber)
  } else {
    return false
  }
}

// 从图片元素获取src的base64数据
function b64toBlob (resultImageObj, contentType = 'image/jpg', sliceSize = 512) {
  // old
  // console.log(resultImageObj)
  const data = resultImageObj
  const imgBase64Reg = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,/
  // const b64Data = data.replace('data:' + contentType + ';base64,', '')
  const b64Data = data.replace(imgBase64Reg, '')
  console.log('b64Data', b64Data)
  // 解码被base-64编码过的数据
  let byteCharacters = atob(b64Data)
  let byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize)
    let byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    // 8位无符号整型数组
    let byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  // Blob 对象是包含有只读原始数据的类文件对象
  const blob = new Blob(byteArrays, { type: contentType })
  return blob

  // 新方式，有问题
  // const arr = resultImageObj.split(',')
  // const mime = arr[0].match(/:(.*?);/)[1]
  // const bstr = atob(arr[1])
  // let n = bstr.length
  // const u8arr = new Uint8Array(n)
  // while (n--) {
  //   u8arr[n] = bstr.charCodeAt(n)
  // }
  // return new Blob([u8arr], { type: mime })
}

/**
 * 定时器
*/
class Timer {
  constructor(total, delay = 1000) {
    this.total = total
    this.delay = delay
    this.num = total
    this.timer = null
  }
  run(cb = () => {}) {
    const {delay} = this
    console.log('xxx1', this.num)
    this.num = this.num - 1
    cb(this.num)
    console.log('xxx', this.num)
    if (this.num > 0) {
      this.timer = setTimeout(() => {
        this.run(cb)
      }, delay)
    } else {
      this.end()
    }
  }
  cancel() {
    const timer = this.timer
    timer && clearTimeout(timer)
  }
  end() {

  }
}

export function formatTime(time, option) {
  const diff = moment().diff(time) / 1000
  console.log('diff', diff)
  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    console.log('hour')
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff > 3600 * 24) {
    console.log('day')
    return '1天前'
  }
  return diff
}

// 判断是否在当前时间段
export function isDuringDate(beginDateStr, endDateStr) {
  var curDate = new Date()
  var beginDate = new Date(Date.parse(beginDateStr.replace(/-/g, '/')))
  var endDate = new Date(Date.parse(endDateStr.replace(/-/g, '/')))
  // debugger
  if (curDate >= beginDate && curDate <= endDate) {
    return true
  }
  return false
}

// 比较时间 0 相等 -1 小于当前时间  1大于当前时间
export function checkDate(dateStr) {
  var curDate = new Date()
  // debugger
  var beginDate = new Date(Date.parse(dateStr.replace(/-/g, '/')))
  if (curDate === beginDate) {
    return 0
  }
  if (beginDate < curDate) {
    // 小于当前时间
    return -1
  }
  if (beginDate > curDate) {
    // 大于当前时间
    return 1
  }
  return -2
}

// 比较时间剩余 type 大于当前时间传0，小于传1
export function getRemainTime(time) {
  // debugger
  var date = new Date()
  var now = date.getTime()
  var time1 = time.split('.')[0]
  var endDate = new Date(Date.parse(time1.replace(/-/g, '/')))
  var endTime = endDate.getTime()

  var cal
  if (endTime > now) {
    cal = endTime - now
  } else {
    cal = now - endTime
  }
  var d, h, m, s
  var str = ''

  if (cal >= 0) {
    d = Math.floor(cal / 1000 / 60 / 60 / 24)
    if (d > 0) {
      str = `${d}天`
    }
    h = Math.floor(cal / 1000 / 60 / 60 % 24)
    m = Math.floor(cal / 1000 / 60 % 60)
    s = Math.floor(cal / 1000 % 60)
    str += `${h}时${m}分${s}秒`
  }
  return str
}

/**
 * @name 生成截图
 * @param {Element} canvasBox 截图区域dom对象
 */
export const createScreenshot = (canvasBox, down = true) => {
  return new Promise((resolve, reject) => {
    // 手动创建一个 canvas 标签
    const canvas = document.createElement('canvas')
    // 获取父级的宽高 clientHeight
    // const width = parseInt(canvasBox.width)
    // const height = parseInt(canvasBox.height)
    const width = parseInt(canvasBox.clientWidth)
    const height = parseInt(canvasBox.clientHeight)
    // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
    canvas.width = width * 2
    canvas.height = height * 2
    canvas.style.width = width + 'px'
    canvas.style.height = height + 'px'
    const context = canvas.getContext('2d')
    context.scale(2, 2)
    html2canvas(canvasBox, {
      allowTaint: true
    }).then((canvas) => {
      // 转换base64
      const capture = canvas.toDataURL('image/png', 0.5)
      // 下载浏览器弹出下载信息的属性
      const date = new Date()
      const saveInfo = {
        // 导出文件格式自己定义，我这里用的是时间作为文件名
        download: date.getTime() + `.png`,
        href: capture
      }
      // 下载，浏览器弹出下载文件提示
      down && downloadFileByBase64(saveInfo.href, saveInfo.download)
      // down && downloadFile(saveInfo)
      resolve(capture)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @name 下载文件
 * @param {Object} saveInfo 下载参数内容
 */
export const downloadFile = (saveInfo) => {
  const element = document.createElement('a')
  element.style.display = 'none'
  for (const key in saveInfo) {
    element.setAttribute(key, saveInfo[key])
  }
  document.body.appendChild(element)
  element.click()
  setTimeout(() => {
    document.body.removeChild(element)
  }, 300)
}

function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

function downloadFileByUrl(url, name) {
  var a = document.createElement('a') // 新建一个a链接
  a.setAttribute('href', url) // a链接的url为图片的url
  a.setAttribute('download', name)
  a.setAttribute('target', '_blank')
  let clickEvent = document.createEvent('MouseEvents')
  clickEvent.initEvent('click', true, true)
  a.dispatchEvent(clickEvent)
}

// 73so.com
function downloadFileByBase64(base64, name) {
  var myBlob = dataURLtoBlob(base64)
  var myUrl = URL.createObjectURL(myBlob) // 创建图片的临时url
  downloadFileByUrl(myUrl, name)
}

/**
 * 从URL中提取指定参数的值。
 *
 * @param {string} url - 包含查询字符串的完整URL。
 * @param {string} param - 要提取的参数名称。
 * @returns {string|null} - 返回参数的值，如果没有找到则返回null。
 */
function getParamValueFromUrl(url, param) {
  // 找到哈希部分并创建一个新的 URLSearchParams 对象来解析它
  const hashParams = new URLSearchParams(url.split('#')[1].split('?')[1])
  return hashParams.get(param)
}

function removeSpecificParam(url, paramName) {
  // 解析URL并分离出哈希部分
  const urlObj = new URL(url)
  let hashPart = urlObj.hash

  // 移除哈希符号并分割成两部分：路径和查询字符串
  hashPart = hashPart.substring(1)
  const [path, queryString] = hashPart.split('?')

  // 创建URLSearchParams对象来处理查询字符串
  const params = new URLSearchParams(queryString)

  // 删除指定的参数
  params.delete(paramName)

  // 重新构建哈希部分
  const newHash = path + (params.toString() ? '?' + params.toString() : '')

  // 更新URL对象中的哈希，并返回新的URL字符串
  urlObj.hash = newHash
  return urlObj.toString()
}

function addOrUpdateParam(url, paramName, paramValue) {
  // 创建一个 URL 对象来解析原始 URL
  const urlObj = new URL(url)

  // 如果哈希中包含查询字符串，我们将其与URL的搜索部分合并处理
  let hashQueryString = ''
  if (urlObj.hash.includes('?')) {
    hashQueryString = urlObj.hash.split('?')[1]
    urlObj.hash = '' // 清空hash以便正确编码新的查询参数
  }

  // 将现有的查询字符串和可能存在的哈希查询字符串合并到一个新的 URLSearchParams 对象中
  const params = new URLSearchParams([...urlObj.searchParams.entries(), ...new URLSearchParams(hashQueryString).entries()])

  // 设置参数（添加或更新）
  params.set(paramName, paramValue)

  // 更新 URL 的搜索部分
  urlObj.search = params.toString()

  // 如果原始 URL 中有哈希（不包括查询字符串），则保留它
  if (urlObj.hash === '' && hashQueryString) {
    urlObj.hash = '#' + hashQueryString.split('&').find(item => !item.startsWith(`${paramName}=`))
  }

  // 返回更新后的 URL 字符串
  return urlObj.toString()
}

/**
 * 表单数据验证函数
 * @param {Object} formData - 表单数据对象
 * @param {Object} rules - 验证规则对象
 * @returns {boolean} - 验证是否通过
 */
function validateData(formData, rules) {
  for (const field in rules) {
    if (rules.hasOwnProperty(field)) {
      const fieldRules = rules[field]
      const value = formData[field]

      for (const rule of fieldRules) {
        // 检查必填项
        if (rule.required && (!value && value !== 0)) {
          // 使用 vux toast 显示错误消息
          if (window.vux && window.vux.toast) {
            window.vux.toast.text(rule.message || '请填写必填项')
          } else if (console) {
            console.warn(rule.message || '请填写必填项')
          }
          return false
        }

        // 检查自定义验证器
        if (rule.validator) {
          let isValid = true
          rule.validator({ field }, value, (error) => {
            if (error) {
              isValid = false
              if (window.vux && window.vux.toast) {
                window.vux.toast.text(error.message || '验证失败')
              } else if (console) {
                console.warn(error.message || '验证失败')
              }
            }
          })
          if (!isValid) {
            return false
          }
        }
      }
    }
  }
  return true
}

export {
  rap, //
  getUrlParam,
  getUrlParams,
  getHashParms, //
  fetch, //
  checkphone, //
  checkRealName,
  checkPwd,
  spliceList,
  strToList,
  setPhone,
  setIdCard,
  checkPwdTrim,
  AnalyzePasswordSecurityLevel,
  idCard,
  checkEmail,
  datetimeFormat,
  trim,
  currency, //
  omit,
  TenThousand,
  getCookie, //
  setCookie,
  isVehicleNumber,
  Timer,
  b64toBlob,
  getParamValueFromUrl,
  removeSpecificParam,
  addOrUpdateParam,
  validateData
}



// WEBPACK FOOTER //
// ./src/utils/common.js